import { useContext } from 'react';
import { ExtensionMessagingContext } from './ExtensionMessagingContext';

export function useExtensionMessagingContext() {
  const context = useContext(ExtensionMessagingContext);
  if (!context) {
    throw new Error(
      'useExtensionMessagingContext must be used within a ExtensionMessagingContext.Provider'
    );
  }
  return context;
}
